
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



  const cardData =
  {
    keyword: 'Ertiga on Rent in Pune',
    heading: 'AB Ghule Cabs: Ertiga on Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers reliable, comfortable, and affordable Ertiga rental services in Pune. Whether you are planning a family trip, business travel, or a weekend getaway, our well-maintained Ertiga vehicles are perfect for local travel, long-distance journeys, or sightseeing tours. With spacious interiors, modern amenities, and experienced drivers, we ensure a comfortable and hassle-free journey for you and your group.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Ertiga Rental in Pune',

    "topPlaces": [
  {
    title: "Spacious and Comfortable",
    description: "Our Ertiga vehicles offer ample legroom, comfortable seating, and air-conditioning to ensure a relaxing journey for all passengers."
  },
  {
    title: "Affordable Pricing",
    description: "We provide competitive rates for both short-term and long-term rentals. Whether it's a one-day trip or a longer journey, we offer transparent and budget-friendly pricing."
  },
  {
    title: "Experienced Drivers",
    description: "Our professional drivers are well-trained to navigate Pune’s roads safely and efficiently. They are also knowledgeable about the best routes and tourist spots, ensuring a smooth and enjoyable ride."
  },
  {
    title: "Perfect for Small Groups",
    description: "The Ertiga is ideal for small groups or families, accommodating up to 7 passengers comfortably. Whether you're heading for a local trip or a long-distance journey, the Ertiga is a great choice for group travel."
  },
  {
    title: "24/7 Availability",
    description: "Our Ertiga rental services are available around the clock. Whether you're planning an early morning departure or a late-night return, we are always available to cater to your needs."
  },
  {
    title: "Customizable Packages",
    description: "We offer customizable packages for family trips, business travel, corporate events, or sightseeing tours. Choose the duration, destinations, and services that best suit your needs."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All our Ertiga vehicles are regularly serviced and maintained to ensure a smooth and trouble-free ride. Cleanliness and hygiene are top priorities, and every vehicle is sanitized before your trip."
  },
  {
    title: "Tourist Sightseeing in Pune and Nearby Areas",
    description: "Our Ertiga vehicles are perfect for sightseeing trips within Pune and nearby destinations like Lonavala, Mahabaleshwar, Sinhagad Fort, and more. Explore the beauty of Pune and its surroundings with comfort."
  },
  {
    title: "Easy Booking Process",
    description: "Booking an Ertiga with AB Ghule Cabs is easy and hassle-free. You can book your vehicle online or over the phone, and our customer support team will assist you in customizing your trip."
  },
  {
    title: "No Hidden Charges",
    description: "We believe in transparency. The price you see when booking is the price you pay, with no hidden or extra charges. Enjoy a simple, straightforward, and affordable rental experience."
  }
],


   services: [
    {
      "name": "Ertiga on Rent Pune",
      description: "Looking for an Ertiga on rent in Pune? AB Ghule Cabs offers reliable Ertiga rentals for all your travel needs. Whether you're heading for a family trip, corporate event, or a local commute, our Ertiga cars provide comfort and space for a pleasant journey."
    },
    {
      "name": "Ertiga Car on Rent in Pune",
      description: "Book an Ertiga car on rent in Pune with AB Ghule Cabs. Choose from our well-maintained fleet of Ertiga cars, ideal for both short and long-distance trips. Our cars are equipped with modern amenities to ensure a smooth ride."
    },
    {
      "name": "Ertiga CNG on Rent in Pune",
      description: "AB Ghule Cabs offers Ertiga CNG on rent in Pune. If you're looking for an eco-friendly, fuel-efficient vehicle for your trips, our CNG Ertiga cars are a great option. Book your Ertiga CNG car rental today for a cost-effective travel experience."
    },
    {
      "name": "Ertiga Rent in Pune",
      description: "Rent an Ertiga in Pune with AB Ghule Cabs. Our Ertiga cars are perfect for local and outstation travel, offering ample space, comfort, and affordable rental rates. Whether for personal or business purposes, we have flexible rental options for you."
    },
    {
      "name": "Ertiga Rent Per Km in Pune",
      description: "Looking for the best Ertiga rent per km in Pune? AB Ghule Cabs offers competitive pricing on Ertiga rentals based on distance. Get the most cost-effective solution for your travel needs with our per km rental rates for Ertiga cars."
    },
    {
      "name": "Ertiga Rental Pune",
      description: "AB Ghule Cabs provides Ertiga rental services in Pune for both local and outstation travel. Our Ertiga cars are well-maintained and come with professional drivers for a comfortable and safe journey. Book your Ertiga rental today and enjoy a hassle-free trip."
    },
    {
      "name": "Maruti Ertiga on Rent in Pune",
      description: "Get a Maruti Ertiga on rent in Pune from AB Ghule Cabs. We offer a fleet of well-maintained Maruti Ertiga cars for various occasions. Whether you're planning a family trip or a business outing, our Ertiga cars provide the perfect combination of comfort and reliability."
    },
    {
      "name": "Pune to Shirdi Ertiga on Rent",
      description: "Planning a trip from Pune to Shirdi? Rent an Ertiga car from AB Ghule Cabs for a comfortable and convenient journey. We offer a variety of cab packages, including one-way and round-trip options, ensuring a smooth and enjoyable ride to Shirdi."
    },
    {
      "name": "Pune to Shirdi Cab Package",
      description: "AB Ghule Cabs offers Pune to Shirdi cab packages, including Ertiga on rent. Our Shirdi cab package offers an affordable and comfortable ride with flexible options for your group size. Book your Pune to Shirdi cab package today for a stress-free journey."
    },
    {
      "name": "Pune Airport to Shirdi Ertiga Cab Package",
      description: "Book an Ertiga cab for your journey from Pune Airport to Shirdi. AB Ghule Cabs provides comfortable and reliable airport transfers with our well-maintained Ertiga cars. Choose from flexible cab packages for a smooth ride from Pune Airport to Shirdi."
    },
    {
      "name": "Pune to Mahabaleshwar Ertiga Cab",
      description: "Planning a trip to Mahabaleshwar? AB Ghule Cabs offers Ertiga cabs for your journey from Pune to Mahabaleshwar. Our fleet of well-maintained cars ensures a comfortable and scenic drive to this beautiful hill station."
    },
    {
      "name": "Pune to Kolhapur Ertiga Cab",
      description: "Rent an Ertiga cab for your trip from Pune to Kolhapur. AB Ghule Cabs offers affordable and reliable Ertiga rentals for outstation trips like Kolhapur. Whether it's for a family trip or a religious visit, our cabs ensure comfort throughout the journey."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab Booking",
      description: "Book an Ertiga cab for your trip from Pune to Mumbai. AB Ghule Cabs offers comfortable and hassle-free Ertiga cabs for outstation travel. Whether it's a one-way or round trip, we provide flexible booking options at competitive rates."
    },
    {
      "name": "Pune to Lonavala Ertiga Cab Booking",
      description: "Going to Lonavala from Pune? Rent an Ertiga car from AB Ghule Cabs for a comfortable journey. Our Ertiga cars are ideal for short-distance trips like Pune to Lonavala, providing both comfort and convenience."
    },
    {
      "name": "Pune to Goa Ertiga Cab",
      description: "Rent an Ertiga cab for your trip to Goa from Pune. AB Ghule Cabs offers affordable and reliable Ertiga cabs for long-distance travel, ensuring comfort and convenience during your journey to Goa. Book your Pune to Goa Ertiga cab today."
    },
    {
      "name": "Pune to Mumbai Airport Ertiga Cab",
      description: "Need a ride to Mumbai Airport? Rent an Ertiga car from AB Ghule Cabs for a comfortable and hassle-free airport transfer. Our Ertiga cabs are perfect for both local and outstation trips, including airport transfers to Mumbai."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Ertiga Cab",
      description: "Going for Ashtavinayak Darshan from Pune? Rent an Ertiga car from AB Ghule Cabs for a convenient and comfortable trip. Our Ertiga cabs are perfect for long-distance religious tours, ensuring a smooth ride throughout."
    },
    {
      "name": "Pune to Shani Shingnapur Ertiga Cab",
      description: "Book an Ertiga cab for your trip to Shani Shingnapur from Pune. AB Ghule Cabs provides comfortable Ertiga cabs for religious tours like Shani Shingnapur, ensuring a safe and enjoyable journey."
    },
    {
      "name": "Pune to Outstation Ertiga Cab",
      description: "Planning an outstation trip? Rent an Ertiga cab from AB Ghule Cabs for a smooth and comfortable journey. Whether it’s a short or long-distance trip, our Ertiga cabs offer ample space and comfort for all your travel needs."
    },
    {
      "name": "Pune to Solapur Ertiga Cab",
      description: "AB Ghule Cabs offers Ertiga cabs for your journey from Pune to Solapur. Our well-maintained Ertiga cars are perfect for both local and outstation travel. Book your Pune to Solapur Ertiga cab today for a convenient and comfortable trip."
    },
    {
      "name": "Ertiga On Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Ertiga on Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Ertiga on Rent Pune", "- Ertiga car on rent in Pune"],
    ["Ertiga CNG on Rent in Pune", "- Ertiga rent in Pune"],
    ["Ertiga Rent Per KM in Pune", "- Ertiga rental Pune"],
    ["Maruti Ertiga on Rent in Pune", "- Pune to Shirdi Ertiga on Rent"],
    ["Pune to Shirdi Cab Package", "- Pune Airport to Shirdi Ertiga Cab Package"],
    ["Pune to Mahabaleshwar Ertiga Cab", "- Pune to Kolhapur Ertiga Cab"],
    ["Pune to Mumbai Ertiga Cab Booking", "- Pune to Lonavala Ertiga Cab Booking"],
    ["Pune to Goa Ertiga Cab", "- Pune to Mumbai Airport Ertiga Cab"],
    ["Pune to Ashtavinayak Darshan Ertiga Cab", "- Pune to Shani Shingnapur Ertiga Cab"],
    ["Pune to Outstation Ertiga Cab", "- Pune to Solapur Ertiga Cab"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Spacious and Comfortable Ride",
      WhyChoosedescription: "The Ertiga is known for its spacious interiors, making it the perfect choice for families, small groups, or business travel. With ample legroom and comfortable seating for up to 7 passengers, it's designed to ensure a comfortable and pleasant journey."
    },
    {
      WhyChooseheading: "Well-Maintained and Clean Vehicles",
      WhyChoosedescription: "At AB Ghule Cabs, we take pride in our fleet. The Ertiga is regularly cleaned, maintained, and inspected to ensure that you have a hassle-free travel experience. We guarantee that our vehicles are in excellent condition for your comfort and safety."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rental rates for the Ertiga without compromising on quality. Our pricing is clear, and we have no hidden fees. Whether you need the car for a few hours or several days, you’ll enjoy affordable rates and complete transparency."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are highly trained, courteous, and experienced in handling both short trips and long-distance journeys. They are committed to providing you with a safe, smooth, and pleasant experience on the road."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Whether you need an Ertiga for a day trip, a weekend getaway, or an extended rental, we provide flexible options to meet your specific requirements. We offer tailor-made rental packages for leisure, business, or family outings."
    },
    {
      WhyChooseheading: "Convenient Booking Process",
      WhyChoosedescription: "Booking an Ertiga on rent is simple and quick with AB Ghule Cabs. You can make a reservation via our website, app, or by calling our customer service. We ensure a seamless booking process that fits into your schedule."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guaranteed",
      WhyChoosedescription: "At AB Ghule Cabs, your satisfaction is our priority. We strive to provide you with the best possible experience by offering reliable services, quality vehicles, and excellent customer support throughout your rental period."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an Ertiga on rent?',
      answer: 'You can book an Ertiga through our website, mobile app, or by calling our customer service team. We ensure a hassle-free and quick booking process.',
    },
    {
      id: 'FAQ2',
      question: 'How many passengers can the Ertiga accommodate?',
      answer: 'The Ertiga can comfortably accommodate up to 7 passengers with enough space for luggage. It\'s perfect for families or small groups traveling together.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Ertiga available for both local and outstation trips?',
      answer: 'Yes, the Ertiga is available for both local Pune trips as well as outstation travel. Whether you’re planning a city tour or a long-distance journey, it’s a great choice.',
    },
    {
      id: 'FAQ4',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our Ertiga vehicles are fully air-conditioned to ensure a comfortable ride, even in the hot weather.',
    },
    {
      id: 'FAQ5',
      question: 'What is the rental cost for the Ertiga?',
      answer: 'The rental cost for the Ertiga varies depending on the duration, distance, and location. We offer affordable pricing and will provide you with a detailed quote upon booking.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent the Ertiga for a few hours?',
      answer: 'Yes, we offer flexible rental packages, including hourly rentals for short trips. You can book the Ertiga for as long as you need, whether for a few hours or several days.',
    },
    {
      id: 'FAQ7',
      question: 'Are the drivers experienced and reliable?',
      answer: 'Yes, all our drivers are well-trained, experienced, and familiar with local and outstation routes. They are also background-checked for your safety.',
    },
    {
      id: 'FAQ8',
      question: 'How do I make payment for the rental?',
      answer: 'You can pay for the Ertiga rental through multiple methods, including cash, credit/debit cards, or online payment via our mobile app.',
    },
    {
      id: 'FAQ9',
      question: 'Can I make changes to my booking after confirming it?',
      answer: 'Yes, modifications to your booking can be made, subject to availability. Please contact our customer service team for assistance with any changes.',
    },
    {
      id: 'FAQ10',
      question: 'Do you provide rental for corporate or business purposes?',
      answer: 'Yes, we offer Ertiga rentals for business meetings, corporate travel, and other professional requirements. We can tailor our service to fit your company’s needs.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Ravi Sharma',
      feedback: 'I rented an Ertiga from AB Ghule Cabs for a family trip to Lonavala, and the experience was great. The car was clean, spacious, and comfortable, making our journey really enjoyable. The driver was friendly and ensured we had a safe trip. I will definitely consider using their services again for future trips.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Meera Joshi',
      feedback: 'We used the Ertiga for a corporate outing, and the service was excellent. The vehicle was well-maintained and comfortable for our team. The driver was professional, and the booking process was easy. Highly recommend AB Ghule Cabs for anyone looking to rent a reliable vehicle in Pune.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Ertiga on Rent in Pune | Affordable Ertiga Car Hire & Rentals</title>
  <meta name="description" content="Ertiga rental services in Pune. Offering affordable Ertiga car hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings." />
  <meta name="keywords" content="Ertiga on Rent Pune, Ertiga car on rent in Pune, Ertiga cng on rent in Pune, Ertiga rent in pune, Ertiga rent per km in pune, Ertiga rental pune, Maruti Ertiga on rent in Pune, Pune to Shirdi Ertiga on rent, Pune to Shirdi cab package, Pune airport to Shirdi Ertiga cab package, Pune to Mahabaleshwar Ertiga cab, Pune to Kolhapur Ertiga cab, Pune to Mumbai Ertiga cab booking, Pune to Lonavala Ertiga cab booking, Pune to Goa Ertiga cab, Pune to Mumbai airport Ertiga cab, Pune to Ashtavinayak darshan Ertiga cab, Pune to Shani Shingnapur Ertiga cab, Pune to outstation Ertiga cab, Pune to Solapur Ertiga cab" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Ertiga on Rent in Pune | Affordable Ertiga Car Hire & Rentals" />
  <meta property="og:description" content="Ertiga rental services in Pune. Offering affordable Ertiga car hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/ertiga-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/ertiga-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Ertiga on Rent in Pune",
        description: "Ertiga rental services in Pune. Offering affordable Ertiga car hire for local and outstation trips including Shirdi, Mahabaleshwar, Mumbai, Goa, and more. Book online or call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/ertiga-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/ertiga-rent.jpg",
        "image": "https://abghulecabs.com/images/ertiga-rent.jpg",
        "priceRange": "₹1500 - ₹4000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/ertiga-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "130"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi K"
            },
            "datePublished": "2024-11-05",
            "reviewBody": "We rented the Ertiga for our trip to Shirdi. It was a comfortable and smooth journey. The driver was professional, and the car was clean. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-10-17",
            "reviewBody": "Great experience with AB Ghule Cabs. The Ertiga was in excellent condition, and the service was reliable. Thank you for making our trip to Mahabaleshwar comfortable."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Ertiga Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/ertiga-on-rent-in-pune"
        },
        "keywords": "Ertiga on Rent Pune, Ertiga car on rent in Pune, Ertiga cng on rent in Pune, Ertiga rent in pune, Ertiga rent per km in pune, Ertiga rental pune, Maruti Ertiga on rent in Pune, Pune to Shirdi Ertiga on rent, Pune to Shirdi cab package, Pune airport to Shirdi Ertiga cab package, Pune to Mahabaleshwar Ertiga cab, Pune to Kolhapur Ertiga cab, Pune to Mumbai Ertiga cab booking, Pune to Lonavala Ertiga cab booking, Pune to Goa Ertiga cab, Pune to Mumbai airport Ertiga cab, Pune to Ashtavinayak darshan Ertiga cab, Pune to Shani Shingnapur Ertiga cab, Pune to outstation Ertiga cab, Pune to Solapur Ertiga cab"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/47.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Ertigaonrentinpune;